module.exports = __webpack_public_path__ + "img/TRANSITIONS-SIGNATURE-5.b1b1bc2b.gif";